import Lottie from 'react-lottie';
import { useMoralis } from 'react-moralis';
import { useEffect, useState } from 'react';
import ErrorAnimation from '../assets/animations/error.json';

const ChechChain = () => {
  const { isWeb3Enabled, Moralis, web3 } = useMoralis();
  const [isMatic, setIsMatic] = useState(true);

  const options = {
    loop: false,
    autoplay: true,
    animationData: ErrorAnimation,
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice',
    },
  };

  useEffect(() => {
    (async () => {
      if (isWeb3Enabled) {
        Moralis.Web3.onChainChanged(async () => {
          const chainID = await Moralis.getChainId();
          if (chainID === 80001) {
            setIsMatic(true);
          } else {
            setIsMatic(false);
          }
        });
      }
    })();
  }, [isWeb3Enabled, Moralis, web3]);

  return !isMatic ? (
    <div className='absolute grid place-items-center top-0 min-w-full min-h-screen'>
      <div className='absolute top-0 min-w-full min-h-screen bg-black opacity-80 z-10'></div>
      <div className='flex flex-col justify-center items-center w-11/12 md:w-7/12 lg:w-4/12 rounded-xl p-4 container-bg z-20'>
        <div className='h-36 w-36'>
          <Lottie options={options} />
        </div>
        <h1 className='italic text-sm'>Please switch to Matic Mumbai</h1>
        <button
          className='bg-purple-700 text-sm px-4 py-2 rounded-xl mt-6'
          onClick={async () => {
            const a = await Moralis.switchNetwork(80001);
          }}
        >
          Switch
        </button>
      </div>
    </div>
  ) : (
    <></>
  );
};

export default ChechChain;
